module.exports = __webpack_public_path__ + "static/media/hero_couple.bd2ef5af.jpg";